export { default } from './CookieSettingsForm';
